import LegislativnyMaterialDetail, {
  AKT_EU,
} from '../model/legislativnyMaterial/LegislativnyMaterialDetail';
import CurrentUserDetail from '../model/currentuser/CurrentUserDetail';
import { StadiumMaterialuEnum } from '../model/legislativnyMaterial/StadiumMaterialu';
import { UserRoleEnum } from '../model/currentuser/UserRole';

const isDefined = (pouzivatel: CurrentUserDetail, materialDetail: LegislativnyMaterialDetail): boolean => !!pouzivatel
    && !!materialDetail
    && !!materialDetail.aktualnyPredkladatel
    && !!materialDetail.aktualnaPredkladatelskaInstitucia;

export const pouzivatelIsPrihlaseny = (pouzivatel: CurrentUserDetail): boolean => !!(pouzivatel && pouzivatel.uuid);

export const pouzivatelIsAdmin = (pouzivatel: CurrentUserDetail)
    : boolean => !!pouzivatel && pouzivatel?.roles?.includes(UserRoleEnum.SUPERADMIN);

export const materialFinished = (materialDetail: LegislativnyMaterialDetail): boolean => (
  materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.PROCES_UKONCENY
    || materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE
);

export const pouzivalHasLegOrg = (pouzivatel: CurrentUserDetail):
    boolean => pouzivatelIsPrihlaseny(pouzivatel)
    && !!pouzivatel.roles
    && !pouzivatel?.roles?.includes(UserRoleEnum.NELEGISLATIVNA_ORGANIZACIA)
    && !pouzivatel?.roles?.includes(UserRoleEnum.VEREJNOST);

export const canUpdatePredkladatel = (
  pouzivatel: CurrentUserDetail,
  materialDetail: LegislativnyMaterialDetail,
): boolean => materialDetail?.typ?.uuid !== AKT_EU
    && ((isDefined(pouzivatel, materialDetail)
            && pouzivatelIsAdmin(pouzivatel)
            && [StadiumMaterialuEnum.PROCES_UKONCENY, StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE]
              .every(stadium => materialDetail?.stadium?.hodnota !== stadium))
        || (isDefined(pouzivatel, materialDetail)
            && pouzivatel.organizaciaUuid === materialDetail?.aktualnaPredkladatelskaInstitucia?.ldapUuid
            && pouzivatel?.uuid === materialDetail?.aktualnyPredkladatel?.uuid
            && materialDetail?.hasOpravneniePracovneKroky));

export const canUpdateMaterial = (
  pouzivatel: CurrentUserDetail,
  materialDetail: LegislativnyMaterialDetail,
): boolean => (pouzivatelIsAdmin(pouzivatel)
        && materialDetail?.stadium?.hodnota !== StadiumMaterialuEnum.PROCES_UKONCENY
        && materialDetail?.stadium?.hodnota !== StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE)
    || (isDefined(pouzivatel, materialDetail)
        && materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.PRIPRAVA_MATERIALU
        && pouzivatel?.organizaciaUuid === materialDetail?.aktualnaPredkladatelskaInstitucia?.ldapUuid
        && pouzivatel?.uuid === materialDetail?.aktualnyPredkladatel?.uuid);

export const canShowNonPublicData = (
  pouzivatel: CurrentUserDetail,
  materialDetail: LegislativnyMaterialDetail,
): boolean => pouzivatelIsAdmin(pouzivatel)
    || (isDefined(pouzivatel, materialDetail)
        && pouzivatel?.organizaciaUuid === materialDetail?.aktualnaPredkladatelskaInstitucia?.ldapUuid
        && pouzivatel?.uuid === materialDetail?.aktualnyPredkladatel?.uuid);
